import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

const SnackbarSuccessIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} viewBox="0 0 40 40" data-test-id='snackbar-success-icon'>
      <circle cx='20' cy='20' r='20' className='outline' />
      <circle cx='20' cy='20' r='15' className='background' />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M29.071 14.6311C29.735 15.2686 29.7564 16.3237 29.1189 16.9877L20.2181 26.258C19.3982 27.1119 18.0324 27.1119 17.2125 26.258L12.1311 20.9656C11.4936 20.3017 11.5151 19.2466 12.179 18.6091C12.843 17.9716 13.8981 17.993 14.5356 18.657L18.7153 23.0102L26.7145 14.679C27.352 14.0151 28.407 13.9936 29.071 14.6311Z'
        className='content'
      />
    </SvgIcon>
  );
};

export default SnackbarSuccessIcon;
